import { ConfigService } from 'app/config/config.service';
import axios, { CreateAxiosDefaults } from 'axios';
import { LOCAL_STORAGE_TOKEN_KEY } from 'app/agriculture/contexts/RequiredStartupProviders/TokenContext/TokenContextProvider';

export function createAxiosInstance(
    options: Partial<CreateAxiosDefaults> = { baseURL: `${ConfigService.apiUrlRoot}agriculture` },
) {
    const defaultOptions = {
        withCredentials: true,
        withXSRFToken: true,
        xsrfHeaderName: 'X-CSRFToken',
        xsrfCookieName: 'csrftoken',
        ...options,
    };

    if (ConfigService.devMode) {
        const apiToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        if (apiToken === null) throw new Error('NO TOKEN');
        return axios.create({
            headers: { Authorization: `Token ${apiToken}` },
            ...defaultOptions,
        });
    }

    // standard production
    return axios.create(defaultOptions);
}
